import { IsOptional, IsString } from 'class-validator';

export class UpdateDocumentsDto {
  @IsString({ each: true })
  @IsOptional()
  arquivosRemovidos?: string[];
}
